import { client, clientWithoutErrorHandling } from '../http';

export default {

  async getOptimizedMortgageBy(newMortgageParams) {
    const response = await client.post('/api/mortgages/optimized-mortgage', {
      ...newMortgageParams,
    });
    return response.data;
  },

  async getMortgagesSimulations() {
    const response = await client.get('/api/mortgages/calculated-simulations');
    return { simulations: response.data?.simulations, mortgageFromCashflow: response.data?.mortgageFromCashflow };
  },

  async uploadMortgageReport(buffer, fileName) {
    const formData = new FormData();
    formData.append('file', new Blob([buffer], { type: 'application/pdf' }), fileName);
    const response = await clientWithoutErrorHandling.post('/api/mortgages/upload-report', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
